import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatDateFormats } from '@angular/material/core';
import { LocaleService } from 'src/app/services/locale.service';
import { DatepickerCustomHeaderComponent } from '../datepicker-custom-header/datepicker-custom-header.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import * as moment from 'moment';
import * as _ from 'lodash';

export const CUSTOM_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY' // this is how the date will be parsed from input
  },
  display: {
    dateInput: 'dddd DD/MM/YYYY', // this is how the date will get displayed on the input
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'ES-es' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMAT },
  ],
  standalone: false
})
export class DatepickerComponent implements OnInit {

  @Input()
  formGroup!: UntypedFormGroup;

  @Input()
  name!: string;

  @Input()
  placeholder!: string;

  @Input()
  minimumDate!: Date;

  @Input()
  maximumDate?: Date;

  @Input()
  filterDows!: number[];

  @Input()
  displayIcon = true;

  @Input()
  customDateDisplay?: string;

  customHeader = DatepickerCustomHeaderComponent;

  constructor(
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DATE_LOCALE) private _locale: string,
    @Inject(MAT_DATE_FORMATS) public _format: MatDateFormats,
    private localeService: LocaleService,
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
    this._locale = this.localeService.getLocale();
    this._adapter.setLocale(this._locale);

    if(this.customDateDisplay) this._format.display.dateInput = this.customDateDisplay;
  }

  filter = (date: Date | moment.Moment | null): boolean => {
    if(_.isEmpty(this.filterDows)) return true;

    const day = moment(date).day();
    return this.filterDows.includes(day);
  };

  get isMobile() { return this.breakpointObserver.isMatched('(max-width: 767px)'); }
}
